(() => {
  const BFMCta = () => {
    const props = {
      selectors: {
        filmsHome: ".mod--layout-films-home",
        modalPlayer: ".bfm-video__modal-player",
      },
    };
    const init = () => {
      const ctaButtons = document.querySelectorAll(".bfm-cta-item.JS-launcher-CTA");
      const modalSection = document.querySelector(".js-bfm-modal-section");
      const modalContainer = modalSection.querySelector(".js-bfm-modal-container");

      ctaButtons.forEach((ctaButton) => {
        const ctaUrl = ctaButton.getAttribute("data-modal-url");
        const youtubeID = ctaButton.getAttribute("data-youtube-id");
        const isDamVideo = ctaButton.getAttribute("data-video-source") === "dam";
        const isYoutubeVideo = ctaButton.getAttribute("data-video-source") === "youtube";

        if ((isDamVideo && ctaUrl) || (isYoutubeVideo && youtubeID)) {
          let videoElem;
          ctaButton.onclick = function () {
            if (isDamVideo) {
              videoElem = `<video controls playsinline class="bfm-video__modal-player js-video-player"
                  data-dtm-video="${ctaUrl}" data-dtm-component="Video">
                  <source src="${ctaUrl}">
                  </source>
                </video>`;
            } else {
              videoElem = `<iframe 
                            width="1080"
                            height="720"
                            src="https://www.youtube.com/embed/${youtubeID}?autoplay=1&rel=0&playsinline=1&color=white&modestbranding=1"
                            class="bfm-video__modal-player --mod-youtube"
                            frameborder="0"
                            allow="autoplay; encrypted-media"
                            allowfullscreen
                          ></iframe>`;
            }

            modalContainer.innerHTML += videoElem;
            modalSection.style.display = "block";
            modalSection.parentElement.style.display = "block";
            document.body.classList.add("mod--menu-open");
          };
        } else {
          ctaButton.style.display = "none";
        }
      });
    };
    if (document.querySelector(props.selectors.filmsHome)) {
      init();
    }
  };
  document.addEventListener("DOMContentLoaded", BFMCta);
})();
